import React from 'react';
import PropTypes from 'prop-types';

export default function SecurityIcon({ width = 16, height = 20, color = '#17d6cc' }) {
  return (
    <svg
      role="img"
      aria-labelledby="securityIcon"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
    >
      <title id="securityIcon">Security Icon</title>
      <path
        d="M15.63 1.65a1 1 0 0 0-.84-.2A8 8 0 0 1 8.57.18a1 1 0 0 0-1.14 0 8 8 0 0 1-6.22 1.27 1 1 0 0 0-.84.2 1 1 0 0 0-.274.348A1 1 0 0 0 0 2.43v7.45a9 9 0 0 0 3.77 7.33l3.65 2.6a1 1 0 0 0 1.16 0l3.65-2.6A9 9 0 0 0 16 9.88V2.43a1 1 0 0 0-.37-.78zM14 9.88a7 7 0 0 1-2.93 5.7L8 17.77l-3.07-2.2A7 7 0 0 1 2 9.88v-6.3a10 10 0 0 0 6-1.39 10 10 0 0 0 6 1.39v6.3zM9.54 7.6l-2.7 2.7-.9-.9c-.188-.188-.444-.294-.7-.294s-.522.106-.7.294-.294.444-.294.7.106.522.294.7l1.6 1.6a1 1 0 0 0 .71.296 1 1 0 0 0 .71-.296L11 9c.188-.188.294-.444.294-.7s-.106-.522-.294-.7-.444-.294-.7-.294-.522.106-.7.294l-.04.01z"
        fill="#1C1A28"
      />
      <defs>
        <linearGradient
          id="A"
          x1="15.945"
          y1="3.36"
          x2="2.181"
          y2="3.36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color} />
          <stop offset="1" stopColor="#17d68a" />
        </linearGradient>
      </defs>
    </svg>
  );
}

SecurityIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};
